import { render, staticRenderFns } from "./el-progress.vue?vue&type=template&id=24f5fba4"
import script from "./el-progress.vue?vue&type=script&lang=js"
export * from "./el-progress.vue?vue&type=script&lang=js"
import style0 from "./el-progress.vue?vue&type=style&index=0&id=24f5fba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports